module.exports = __webpack_public_path__ + "img/check.06c71184.svg";